if (!customElements.get('quote-callout')) {
  customElements.define('quote-callout', class QuoteCallout extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      const carousel = this.querySelector('.js-quote-callout-carousel')
      const slides = carousel.querySelectorAll('.swiper-slide')

      if (slides.length <= 1) {
        return
      }

      new Swiper(carousel, {
        cssMode: false,
        slidesPerView: 1,
        loop: true,
        speed: 600,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 100000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        lazyPreloadPrevNext: 2
      })
    }
  })
}
